module.exports = __webpack_public_path__ + "static/media/appImage2.798b340d.png";